module.exports = __webpack_public_path__ + "img/assembly-leader.fdddfdb9.png";